document.addEventListener("DOMContentLoaded", function () {
  
  const filterTrigger = document.querySelector('.co-filter-trigger');
  const filterList = document.querySelector('.co-filter-list');
  filterTrigger.addEventListener("click", function (e) {
    e.preventDefault();
    // Check if the parent element already has the 'active' class
    if (!this.classList.contains("active")) {
      this.classList.add("active");
      filterList.classList.add("active");
      // gsap.to(filterList, {
      //   height: "auto",
      //   borderColor: '#fff',
      //   duration: 0.3,
      //   ease: "power2.inOut",
      // });
    } else {
      // remove 'active' if clicked on 'active'
      this.classList.remove("active");
      filterList.classList.remove("active");
      // gsap.to(filterList, {
      //   height: 0,
      //   borderColor: 'transparent',
      //   duration: 0.3,
      //   ease: "power2.inOut",
      // });
    }
    // If already active, don't hide the content
  });

  document.addEventListener("click", function (e) {
    const isClickInsideTrigger = filterTrigger.contains(e.target);
    const isClickInsideList = filterList.contains(e.target);
  
    // If clicked outside both the trigger and the list, hide the list
    if (!isClickInsideTrigger && !isClickInsideList) {
      if (filterTrigger.classList.contains("active")) {
        filterTrigger.classList.remove("active");
        filterList.classList.remove("active");
        // gsap.to(filterList, {
        //   height: 0,
        //   borderColor: 'transparent',
        //   duration: 0.3,
        //   ease: "power2.inOut",
        // });
      }
    }
  });

});
